import { useState, useEffect, useMemo } from "react";
import MainHeader from "./MainHeader";
import SideNav from "./SideNav";
import { Box } from "@mui/material";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from '../pages/Dashboard';
import Leads from "../pages/Leads";
// import LeadsGenerator from "../pages/LeadsGenerator";
import Analytics from "../pages/Analytics";
import FollowUps from "../pages/FollowUps";
//import Settings from "../pages/Settings";
import HelpCenter from "../pages/HelpCenter";
import Subscription from "../pages/Subscription";
// import CampaignBuilder from "../pages/Campaign/CampaignBuilder";
// import AlertsAndNotifications from "../pages/AlertsAndNotifications";
// import AIMessageWriter from "../pages/AIMessageWriter";
import BusinessInfo from "../pages/BusinessInfo";
import Campaigns from "../pages/Campaigns";
import NotFound from "../pages/NotFound";
import Templates from "../pages/Templates";
import Attachments from "../pages/Attachments";
import { getSubscriptionStatus, getUserProfile } from "../api/apiService";
import Users from "../pages/Admin/Users";
import AdminDashboard from "../pages/Admin/AdminDashboard";
import SubscriptionInActive from "../pages/SubscriptionInActive";
import ManageSubscription from "../pages/Admin/ManageSubscription";
import CampaignWorkflow from "../pages/Admin/CampaignWorkflow";

export default function Home() {

    const [collapsed, setCollapsed] = useState(false);
    const [toggled, setToggled] = useState(false);
    const [userData, setUserData] = useState();
    const [loadingProfile, setLoadingProfile] = useState(true);
    const [subscriptionActive, setSubscriptionActive] = useState(false);
    const [subscriptionInfo, setSubscriptionInfo] = useState(null);

    /* fetch clientId from localstorage */
    const clientId = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('clientId')) ?? '';
        } catch {
            return '';
        }
    }, []);

    useEffect(() => {
        const fetchSubscriptionStatus = async () => {
            try {
                const response = await getSubscriptionStatus(clientId);
                const isActive = response?.data?.data?.isActive;
                setSubscriptionActive(isActive === true);
                setSubscriptionInfo(response?.data?.data)
                //console.log("SUB RESPONSE:", response.data.data.isActive);
            } catch (e) {
                setSubscriptionActive(true);
            }
        }
        fetchSubscriptionStatus();
    }, [clientId])

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const res = await getUserProfile();
                setUserData(res?.data?.data ?? res?.data);
            } catch (e) {
                // ignore here; ProtectedRoute will handle auth
            }
            finally {
                setLoadingProfile(false);
            }
        };
        fetchProfile();
    }, []);

    const isAdmin = (() => {
        const role = userData?.role || userData?.userRole || userData?.type;
        const roles = userData?.roles;
        if (typeof role === 'string' && role.toLowerCase() === 'admin') return true;
        if (Array.isArray(roles) && roles.map(r => String(r).toLowerCase()).includes('admin')) return true;
        if (userData?.isAdmin === true) return true;
        return false;
    })();

    if (loadingProfile) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
            </Box>
        );
    }

    return (
        <>
            {/* Header section */}
            <MainHeader
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                toggled={toggled}
                setToggled={setToggled}
                isAdmin={isAdmin}
                subscriptionInfo={subscriptionInfo}
            />
            {/* Body section */}
            <Box sx={styles.container}>

                {/* Side bar */}
                <SideNav
                    collapsed={collapsed}
                    toggled={toggled}
                    setToggled={setToggled}
                    isAdmin={isAdmin}
                />
                {/* Content section */}
                <Box component={'main'} sx={styles.mainSection}>
                    <Routes>
                        {/* 1️. ADMIN ROUTES */}
                        {isAdmin && (
                            <>
                                <Route path="/" element={<Navigate to="/home/admin" replace />} />
                                <Route path="/admin" element={<AdminDashboard />} />
                                <Route path="/users" element={<Users />} />
                                <Route path="/subscriptions" element={<ManageSubscription />} />
                                <Route path="/campaign-workflow" element={<CampaignWorkflow />} />
                                <Route path="*" element={<Navigate to="/home/users" replace />} />
                            </>
                        )}
                        {/* 2️. SUBSCRIPTION INACTIVE ROUTES */}
                        {!isAdmin && !subscriptionActive && (
                            <>
                                <Route path="/" element={<SubscriptionInActive />} />
                                <Route path="/subscription" element={<Subscription />} />
                                <Route path="*" element={<SubscriptionInActive />} />
                            </>
                        )}
                        {/* 3. ACTIVE SUBSCRIBER ROUTES */}
                        {!isAdmin && subscriptionActive && (
                            <>
                                <Route path="/" element={<Dashboard />} />
                                <Route path="/business" element={<BusinessInfo />} />
                                <Route path="/leads" element={<Leads />} />
                                {/* <Route path="/leadsGen" element={<LeadsGenerator/>}/>  */}
                                {/* <Route path="/aiMessage" element={<AIMessageWriter/>}/> */}
                                {/* <Route path="/buildCampaign" element={<CampaignBuilder/>}/> */}
                                <Route path="/campaigns" element={<Campaigns />} />
                                <Route path="/followUps" element={<FollowUps />} />
                                <Route path="/templates" element={<Templates />} />
                                <Route path="/attachments" element={<Attachments />} />
                                <Route path="/analytics" element={<Analytics />} />
                                <Route path="/subscription" element={<Subscription />} />
                                {/* <Route path="/settings" element={<Settings/>}/> */}
                                {/* <Route path="/alerts" element={<AlertsAndNotifications/>}/> */}
                                <Route path="/helpCenter" element={<HelpCenter />} />
                                <Route path="*" element={<NotFound />} />
                            </>
                        )}
                    </Routes>
                </Box>
            </Box>

        </>
    );
}

/** @type {import("@mui/material").SxProps} */
const styles = {
    container: {
        display: 'flex',
        bgcolor: 'neutral.light',
        height: 'calc(100% - 64px)',
    },
    mainSection: {
        p: 4,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        // backgroundColor: '#eeeeee'
        background: 'linear-gradient(180deg, #f8fafc 0%, #eef2ff 60%, #ffffff 100%)'
    }

}

